"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_OPTIONS = void 0;
const tslib_1 = require("tslib");
const react_1 = require("react");
const react_intersection_observer_1 = require("react-intersection-observer");
const use_timeout_once_1 = tslib_1.__importDefault(require("../../lib/use-timeout-once"));
exports.DEFAULT_OPTIONS = { threshold: 0.5, fallbackInView: true };
const defaultTimeToImpressionInMilliseconds = 1000;
const useImpressionObserver = ({ timeToImpression = defaultTimeToImpressionInMilliseconds, options, onCreateImpressionWhenView, }) => {
    if (options?.triggerOnce) {
        throw new Error('triggerOnce incompatible with useImpressionObserver');
    }
    const { ref, inView, entry } = (0, react_intersection_observer_1.useInView)({
        ...exports.DEFAULT_OPTIONS,
        ...options,
    });
    const effect = (0, react_1.useCallback)(() => onCreateImpressionWhenView?.(entry), [onCreateImpressionWhenView, entry]);
    (0, use_timeout_once_1.default)(effect, timeToImpression, inView);
    return {
        inViewRef: ref,
    };
};
exports.default = useImpressionObserver;
//# sourceMappingURL=use-impression-observer.js.map